// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2Eopv","unreadBadge":"styles_unreadBadge__mD1Nr","modalContent":"styles_modalContent__2NFHo","modal":"styles_modal__1OPwK"};